import React from "react";

import { ColumnStyle, Steward } from "components/Common/TableStyle";

export const DATA_SOURCE_BUSINESS_TERM_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "20%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "40%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    width: "20%",
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    width: "20%",
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
];
